"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Styled = __importStar(require("./TabStyles"));
var Tab = function (_a) {
    var children = _a.children, _b = _a.activeClassName, activeClassName = _b === void 0 ? "active" : _b, _c = _a.isActive, isActive = _c === void 0 ? false : _c, to = _a.to, _d = _a.isNew, isNew = _d === void 0 ? false : _d, _e = _a.disabled, disabled = _e === void 0 ? false : _e, _f = _a.linkComponent, LinkComponent = _f === void 0 ? react_router_dom_1.NavLink : _f, icon = _a.icon, _g = _a.iconSize, iconSize = _g === void 0 ? 50 : _g;
    return (React.createElement("div", { className: "TabWrapper ".concat(isActive ? activeClassName : "", " ").concat(isNew ? "newTab" : "") }, disabled ? (React.createElement("a", { "aria-disabled": true },
        React.createElement(Styled.ContentWrapper, null,
            icon && React.createElement(Styled.IconWrapper, null, icon),
            children))) : (React.createElement(LinkComponent, { to: to, href: to },
        React.createElement(Styled.ContentWrapper, null,
            icon && React.createElement(Styled.IconWrapper, null, icon),
            children)))));
};
exports.default = Tab;
